<!-- This button triggers the overlay and is its origin -->
<div
  class="w-fit min-w-[2rem]"
  (click)="openMenu()"
  cdkOverlayOrigin="trigger"
  #trigger="cdkOverlayOrigin"
  [class]="classOverrides"
  [class.select-none]="isOpen"
  [class.rounded]="isOpen"
  [class.outline-none]="isOpen"
>
  <ng-container *ngTemplateOutlet="customTriggerRef" />
</div>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen && !isModal"
  [cdkConnectedOverlayPositions]="preferedPosition"
  cdkConnectedOverlayBackdropClass="bg-transparent"
  [cdkConnectedOverlayHasBackdrop]="hasBackdrop"
  (detach)="closeMenu()"
  (backdropClick)="closeMenu()"
>
  <div class="my-1 rounded-lg bg-white shadow-xl">
    <ng-container *ngTemplateOutlet="customOverlayRef" />
  </div>
</ng-template>
